import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SigninModel } from '../../../../security/types';
import { AuthenticationService } from '../../../../security/authentication/authentication.service';
import { NavigationService } from '../../../services/navigation.service';

@Component({
    selector: 'mcb-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
})
export class PortalLoginComponent {
    signinModel: SigninModel = {} as any;
    captcha: Blob;

    constructor(
        private authService: AuthenticationService,
        private navService: NavigationService) {
        this.reloadCaptcha();
    }

    async onFormSubmit() {
        try {
            await this.authService.signin(this.signinModel).toPromise();
            await this.navService.goToAppropriateSecurityPageOrDashboard();
        } catch {
            this.reloadCaptcha();
        }
    }

    reloadCaptcha() {
        this.authService.getCaptcha().subscribe(x => this.captcha = x);
    }
}
